import { colors } from '@shared/interfaces/paleta-cores';

export const REGIAO_PLUVIOMETRICA_CHART_COLORS = [
	'#FDFB80',
	'#295F9D',
	'#63FD66',
	'#FF973A',
	'#FD4B48',
	'#2A832A',
	'#4ECAE6',
];

export const MESORREGIOES_CHART_COLORS = [
	'#E69F00',
	'#e81515',
	'#009E73',
	'#133357',
];

type ItemNomeado = {
	name?: string | null;
};

export const normalizarNome = (value?: string | null): string =>
	(value ?? '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.trim()
		.toLowerCase();

export const ORDEM_REGIOES_PLUVIOMETRICAS = [
	'Alto Sertão',
	'Sertão',
	'Cariri',
	'Curimataú',
	'Agreste',
	'Brejo',
	'Litoral',
].map(normalizarNome);

export const getMapaCores = (
	lista: ItemNomeado[],
	agrupamento: string
): Map<string, string> => {
	const paleta =
		agrupamento === 'REGIAO_PLUVIOMETRICA'
			? REGIAO_PLUVIOMETRICA_CHART_COLORS
			: agrupamento === 'MESORREGIAO'
				? MESORREGIOES_CHART_COLORS
				: colors;

	const nomesOrdenados = lista
		.map(item => item.name)
		.filter(
			(name): name is string =>
				!!name && normalizarNome(name) !== 'estado completo'
		)
		.sort((a, b) => a.localeCompare(b, 'pt-BR', { sensitivity: 'base' }));

	return new Map(
		nomesOrdenados.map((nome, index) => [
			normalizarNome(nome),
			paleta[index % paleta.length],
		])
	);
};

export const getCorPorRegiao = (
	nome: string | undefined,
	listaRegioes: ItemNomeado[],
	agrupamento: string
): string => {
	const mapaCores = getMapaCores(listaRegioes, agrupamento);
	const cor = mapaCores.get(normalizarNome(nome));

	return cor ?? REGIAO_PLUVIOMETRICA_CHART_COLORS[0];
};

export function ordenarRegioesPluviometricas(regioes: string[]): string[] {
	return [...regioes].sort((a, b) => {
		const indexA = ORDEM_REGIOES_PLUVIOMETRICAS.indexOf(normalizarNome(a));
		const indexB = ORDEM_REGIOES_PLUVIOMETRICAS.indexOf(normalizarNome(b));

		if (indexA === -1) return 1;
		if (indexB === -1) return -1;

		return indexA - indexB;
	});
}
